<script>
export default {
  computed: {
    colorStyles () {
      return Object.entries(this.defaultColors).reduce((style, [key, value]) => ({ ...style, ['--' + key + '-color']: value }), {})
    },
    // static
    defaultColors () {
      return {
        main: '#007FFF',
        sub: '#F5FbFF',
        error: '#C1493B',
        alert: '#FA3D3D',
        remind: '#FBA803',
        active: '#70BF30',
        cancel: '#777777',
        font: '#333333',
        border: '#DEDEDE'
      }
    }
  }
}
</script>
